import { render } from "./InputRadioSelect.vue?vue&type=template&id=a095823c&scoped=true"
import script from "./InputRadioSelect.vue?vue&type=script&lang=js"
export * from "./InputRadioSelect.vue?vue&type=script&lang=js"

import "./InputRadioSelect.vue?vue&type=style&index=0&id=a095823c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a095823c"]])

export default __exports__